import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { CallCenterService } from "src/app/services/call-center.service";

@Component({
  selector: "app-patient-dashboard",
  templateUrl: "./patient-dashboard.component.html",
  styleUrls: ["./patient-dashboard.component.scss"],
})
export class PatientDashboardComponent implements OnInit {
  selectedViewHistory$: Subscription;
  patientName: string;

  appointmentsHistory: any = {
    currentAppointments: [],
    pastAppointments: [], // ✅ Add this line
  };
  lastAppointment: any;
  appointmentData: any;
  selectedPatient: any = {}; // ✅ added
  visibleAppointments: number = 3; // Initially, show only 3 appointments
  isExpanded: boolean = false; // To track whether "Show More" is clicked
  showBasicDetailsTable: boolean;
  leadId: any;
  callType: any;
  patientEmail: any;
  CallerStatusAutoId: any;
  patientUHIDMobile: any;
  currentUser: any;
  Patientdetls: {
    fullName: string;
    uhid: any;
    gender: string;
    // bloodGroup: '-',          // Set later if available
    age: any; // Set later if available
    mobile: any;
  };

  constructor(private callCenterService: CallCenterService) {}

  ngOnInit() {
    const data = localStorage.getItem("AppointmentInformation");
    const rawData = localStorage.getItem("CurrentOutBoundCallMobileNumber");

    console.log("rawData", rawData);

    let firstPatientUHID: string | null = null;

    if (data) {
      const parsed = JSON.parse(data);

      this.appointmentData = parsed;
      console.log(parsed.PastAppointments); // Log to verify data

      const upcoming = parsed.UpcomingAppointments || [];
      const past = parsed.PastAppointments || [];

      if (upcoming.length > 0) {
        firstPatientUHID = upcoming[0].patientUHID;

        this.appointmentsHistory.currentAppointments = upcoming;

        // ✅ pick latest by createdOn
        this.lastAppointment = upcoming.reduce((a, b) =>
          new Date(this.normalizeDate(b.createdOn)) >
          new Date(this.normalizeDate(a.createdOn))
            ? b
            : a
        );
      } else if (past.length > 0) {
        this.appointmentsHistory.pastAppointments = past;

        this.lastAppointment = past.reduce((a, b) =>
          new Date(this.normalizeDate(b.createdOn)) >
          new Date(this.normalizeDate(a.createdOn))
            ? b
            : a
        );
      }

      // ✅ Extract patient data from lastAppointment
      if (this.lastAppointment) {
        debugger;
        this.selectedPatient = {
          fullName: `${this.lastAppointment.patientFirstName || ""} ${
            this.lastAppointment.patientLastName || ""
          }`.trim(),
          // uhid: parsedUser.patientUHID || "",
          // gender: parsedUser.gender || "",
          mobile:
            this.lastAppointment.patientMobileNumber ||
            this.lastAppointment.mobileNumber ||
            "",
          age: this.lastAppointment.dateOfBirth
            ? this.calculateAge(this.lastAppointment.dateOfBirth) + " Years"
            : "",
          bloodGroup: this.lastAppointment.bloodGroup || "",
          height: this.lastAppointment.height || "",
          weight: this.lastAppointment.weight || "",
        };
      }
    }
    if (rawData) {
      debugger;
      const parsedUser = JSON.parse(rawData);
      console.log("parsedUser", parsedUser);
      this.Patientdetls = {
        fullName: `${parsedUser.firstName || parsedUser.patientName} ${
          parsedUser.lastName || ""
        }`,
        uhid: localStorage.getItem("SelectedUHIDNumber") || "",
        gender: parsedUser.gender || "",
        // bloodGroup: '-',          // Set later if available
        age: parsedUser.age, // Set later if available
        mobile: parsedUser.phoneNo || "",
        // height: '-',              // Set later if available
        // weight: '-',              // Set later if available
      };
    }
    this.selectedViewHistory$ =
      this.callCenterService.selectedViewHistory.subscribe((value) => {
        if (
          value.isRequestFormPopUp &&
          value.CallerMobileNumber &&
          value.CallerMobileNumber.length == 10
        ) {
          this.showBasicDetailsTable = false;
          this.leadId = value.leadId;
          this.callType = value.callType;
          this.CallerStatusAutoId = value.CallerStatusAutoId;
          this.patientEmail = value.PatientDetails["emailId"];
          this.patientEmail = value.CallerMobileNumber; //value.isNewUser ? value.PatientDetails["phoneNo"] :  value.PatientDetails["mobileNumber"] ;
          this.patientUHIDMobile = value.UHIDMobileNumber; //value.isNewUser ? value.PatientDetails["phoneNo"] :  value.PatientDetails["mobileNumber"] ;
          this.Patientdetls.uhid =value.PatientDetails["uhidNumber"];
          this.patientName =
            value.PatientDetails["firstName"] +
            " " +
            value.PatientDetails["lastName"];
        }
      });
  }
  toggleShowMore() {
    if (this.isExpanded) {
      this.visibleAppointments = 3; // Show only the first 3 appointments when collapsed
    } else {
      this.visibleAppointments =
        this.appointmentsHistory.currentAppointments.length; // Show all appointments
    }
    this.isExpanded = !this.isExpanded; // Toggle the state
  }

  normalizeDate(dateString: string): string {
    if (!dateString) return "";
    const [datePart, timePart = "00:00:00"] = dateString.split(" ");
    const [day, month, year] = datePart.split("-");
    return `${year}-${month}-${day}T${timePart}`;
  }

  calculateAge(dob: string): number {
    if (!dob) return null;

    // Remove time part if it exists
    const datePart = dob.split(" ")[0]; // "17-12-2024"
    const [day, month, year] = datePart.split("-");

    if (!day || !month || !year) return null;

    const birthDate = new Date(+year, +month - 1, +day);
    const ageDifMs = Date.now() - birthDate.getTime();
    const ageDate = new Date(ageDifMs);

    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
}

// setLastAppointment() {
//   const upcoming =
//     this.appointmentData && this.appointmentData.UpcomingAppointments
//       ? this.appointmentData.UpcomingAppointments
//       : [];

//   const past =
//     this.appointmentData && this.appointmentData.PastAppointments
//       ? this.appointmentData.PastAppointments
//       : [];

//   if (upcoming.length > 0) {
//     this.lastAppointment = this.getLatestAppointment(upcoming);
//   } else if (past.length > 0) {
//     this.lastAppointment = this.getLatestAppointment(past);
//   } else {
//     this.lastAppointment = null;
//   }
// }

// getLatestAppointment(appointments: any[]): any {
//   return appointments.reduce((a, b) => {
//     const dateA = this.parseDate(a.createdOn || a.appointmentDate);
//     const dateB = this.parseDate(b.createdOn || b.appointmentDate);
//     return dateB > dateA ? b : a;
//   });
// }

// parseDate(dateStr: string): Date {
//   if (!dateStr) return new Date(0); // fallback

//   const datePart = dateStr.split(" ")[0]; // remove time if exists
//   const parts = datePart.split("-");

//   // Convert dd-mm-yyyy → yyyy-mm-dd
//   if (parts.length === 3 && parts[2].length === 4) {
//     return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
//   }

//   return new Date(dateStr); // fallback
// }
